import { Text } from '@perch-labs/shrike';
import { useState } from 'react';
import { ValidatingInput } from '~/components/validating-input';
import { getContractMap } from '../perch-general-terms.utils';
import { TermsWrapper } from '../perch-general.style';
import { ConsentLink } from './consent-link.component';
import { ContractLink } from './contract-link.component';

export const GeneralTermsAndCreditCheck = ({
  onChange,
  contractIds,
  contracts,
  requireFico,
  consents,
}) => {
  const contractsMap = getContractMap(contracts);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  return (
    <>
      <ValidatingInput
        type="checkbox"
        id="generalTerms"
        label=""
        name="generalTerms"
        title="generalTerms"
        checked={isTermsAccepted}
        value={isTermsAccepted}
        validate={() => isTermsAccepted}
        onChange={value => {
          setIsTermsAccepted(!!value);
          const ids = requireFico
            ? [...contractIds, consents['perch-credit-check-consent'].id]
            : contractIds;
          onChange(ids, {
            name: 'generalContractIds',
            isValid: !!contractIds.length && !!value,
          });
        }}
      />
      <TermsWrapper>
        <Text textStyle="paragraph400" color="secondary" textAlign="left">
          {'By checking this box, I am providing my electronic signature and agree to the '}
          <ContractLink contractKeys={['ESIGN Consent Policy']} contractsMap={contractsMap} />
          {' and confirm that my device meets the required specifications. I also agree to the '}
          {!!requireFico && (
            <>
              <ConsentLink
                labelText="Credit Check Consent"
                headerText="Credit Check Consent"
                bodyContent={consents['perch-credit-check-consent'].notes}
              />
              {', '}
            </>
          )}
          <ContractLink
            contractKeys={['Perch Terms of Service', 'Perch Privacy Policy']}
            contractsMap={contractsMap}
          />
          .
        </Text>
      </TermsWrapper>
    </>
  );
};
